export function updateDecrement(firestore, props, decrement) {
    return firestore.collection("Event").doc(props.title).update({
        likes: decrement
    });
}
